import sequenceComponentState from 'lib/sequence/component/state/index'

const {
  set: take,
  undefine: narrow,
} = sequenceComponentState('block')

const stretch = obj => take(obj, { xs: 12, ms: 12 })
const set = (obj, width) => take(obj, { xs: width, ms: width })

const sequenceComponentStateWidth = {
  set,
  stretch,
  narrow,
}

export {
  sequenceComponentStateWidth as default,
  set,
  stretch,
  narrow,
}
